<template>
  <OmtCard py="12px" pl="14px" pr="18px" :opacity="disabled ? 0.5 : 1"
@click="handleClick">
    <OmtRow>
      <CFlex align-items="flex-start">
        <OmtIcons :name="icon" pt="2px" mr="16px" size="1x" />
        <CFlex flex-direction="column" w="100%">
          <CFlex align-items="center" w="100%">
            <OmtTypography as="h3-bold">{{ title }}</OmtTypography>
            <CBox
              v-if="newFunction"
              bg="var(--colors-light-secondary-gold)"
              border-radius="16px"
              px="5px"
              ml="auto"
              mr="16px"
            >
              <OmtTypography as="p0" font-size="10px" color="white" text-transform="uppercase"> Novo </OmtTypography>
            </CBox>
            <OmtIcons name="chevron-right" :ml="!newFunction ? 'auto' : '0'" />
          </CFlex>
          <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"
pt="8px">
            {{ description }}
          </OmtTypography>
        </CFlex>
      </CFlex>
    </OmtRow>
  </OmtCard>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "RefundCardOption",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    newFunction: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    }
  }
});
</script>

<style scoped>
.opacity-50 {
  opacity: 0.5;
}
</style>
